<template>
  <div class="index">
    <div class="doctor-info flex">
      <img v-if="userInfo.headPic" :src="userInfo.headPic ? imgHost + userInfo.headPic : ''" alt="头像" @click="goPersonCenter">
      <img v-else src="@/assets/default-header.png" alt="头像" @click="goPersonCenter">
      <div class="info" v-if="userInfo.auditStatus == 2 && userInfo.accountStatus ==2">
        <p class="title" @click="goPersonCenter">{{userInfo.nickName}}</p>
        <p class="text">{{userInfo.briefing}}</p>
      </div>
      <div class="info no-pass" >
        <!-- 0:未认证  1:审核中；2：审核通过；3：驳回；4：冻结 -->
        <p class="title" v-if="userInfo.auditStatus == 0 || userInfo.auditStatus == undefined || userInfo.auditStatus == 1" @click="goPersonCenter">未认证游客</p>
        <p class="text" v-if="userInfo.auditStatus == 0 || userInfo.auditStatus == undefined"><span class="re-certification" @click="goPersonCenter">立即认证，</span>审核通过后开始创作</p>
        <p class="text" v-else-if="userInfo.auditStatus == 1">亲爱的JDH京东内容开放平台作者，您的主体资料正在审核中，我们将尽快给您反馈审核结果。审核期间，部分平台功能可能无法正常使用，敬请谅解</p>
        <p class="text" v-else-if="userInfo.auditStatus == 3">审核未通过，<span class="re-certification" @click="goPersonCenter">重新认证</span></p>
        <p class="text" v-else-if="userInfo.auditStatus == 4">账号被冻结</p>
      </div>
    </div>
    <div class="item">
      <p class="c-title">消息中心</p>
      <div class="no-data flex flex-direction-column justify-content-center align-items-center">
        <img src="@/assets/message.png" alt="托底图片">
        <p>暂无消息</p>
      </div>
    </div>
    <div class="item">
      <p class="c-title">数据看板</p>
      <div class="no-data flex flex-direction-column justify-content-center align-items-center">
        <img src="@/assets/no-data.png" alt="托底图片">
        <p>功能开发中，敬请期待</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import breadCrumb from "@/components/breadCrumb";
  export default {
    name: "index",
    data(){
      return{
        tenantId: '',
      }
    },
    components:{
      breadCrumb
    },
    computed:{
    	...mapState([
        'imgHost',
        'userInfo',
      ]),
    },
    mounted(){
    },
    methods:{
      goPersonCenter(){
        if(this.userInfo.auditStatus==2){
          this.$router.push(`/personalCenter/detail`);
        }else {
          this.$router.push(`/personalCenter/update`);
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .index{
    width: 100%;
    .doctor-info{
      height:140px;
      background: white;
      padding: 30px;
      margin-bottom: 20px;
      border-radius: 4px;
      img{
        width: 80px;
        height: 80px;
        border-radius: 40px;
      }
      .info{
        margin-left: 30px;
        p{
          font-size: 14px;
          color: rgba(95,95,107,1);
        }
        .title{
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: rgba(51,56,64,1);
          margin-bottom: 12px;
          margin-left: -10px;
        }
        .text{
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box; // 作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
          -webkit-line-clamp: 2; // 显示的行
        }
      }
      .no-pass{
        .title{
          margin-bottom: 32px;
        }
        .re-certification{
          color: #266CEE;
          cursor: pointer;
        }
      }
    }
    .item{
      height:235px;
      background: white;
      padding: 22px 0 20px 26px;
      margin-bottom: 20px;
      border-radius: 4px;
      .no-data{
        font-size: 12px;
        color: rgba(156,168,185,1);
        height:100%;
        .c-title{
          width: 64px;
          height: 16px;
          line-height: 16px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: rgba(44,52,67,1);
        }
        img{
          width: 170px;
          height:114px;
          margin-bottom: 28px;
        }

      }
    }
  }
</style>
